import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from "react-i18next";
const ExplanationModal = (props) => 
{
    const { t } = useTranslation();
    return(
        <Modal show={props?.show} onHide={props?.closeExplanation} animation={false} size="lg" aria-labelledby="Explanation" centered className="explanation-modal">
                <Modal.Header closeButton>
                    <Modal.Title><span>{t("kclGloves.Explanation")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body className="mx-2">
                    <div className="row mx-0 bor-bottom">
                        <div className="modal-subtitle">{t("kclGloves.Permeation")}</div>
                        <div className="col-sm-6 col-12 p-lg-0">
                            <ul>
                                <li><span>{t("kclGloves.Level")} A:</span> 1 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 5 {t("kclGloves.Mins")}</li>
                                <li><span>{t("kclGloves.Level")} B:</span> 6 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 9 {t("kclGloves.Mins")}</li>
                                <li><span>{t("kclGloves.Level")} 1:</span> 10 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 30 {t("kclGloves.Mins")}</li>
                                <li><span>{t("kclGloves.Level")} 2:</span> 30 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 60 {t("kclGloves.Mins")}</li>
                            </ul>
                        </div>
                        <div className="col-sm-6 col-12">
                            <ul>
                                <li><span>{t("kclGloves.Level")} 3:</span> 60 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 120 {t("kclGloves.Mins")}</li>
                                <li><span>{t("kclGloves.Level")} 4:</span> 120 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 240 {t("kclGloves.Mins")}</li>
                                <li><span>{t("kclGloves.Level")} 5:</span> 240 {t("kclGloves.Mins")} &le; x <span className='less-greater-symbol'>&lt;</span> 480 {t("kclGloves.Mins")}</li>
                                <li><span>{t("kclGloves.Level")} 6:</span> ≥ 480 {t("kclGloves.Mins")}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row mx-0 bor-bottom">
                        <div className="modal-subtitle">{t("kclGloves.Swelling")} </div>
                        <p className="p-lg-0">{t("kclGloves.Swelling_Explain")} </p>
                    </div>
                    <div className="row mx-0 bor-bottom">
                        <div className="modal-subtitle">{t("kclGloves.Swelling_Resistance")}</div>
                        <div className="col-sm-6 col-12 p-lg-0">
                            <ul>
                                <li>+ : {t("kclGloves.Resistant")} <span className='less-greater-symbol'>&lt;</span> {t("kclGloves.Resistant_Percent")}</li>
                                <li>- : {t("kclGloves.Non_Resistant")} <span className='less-greater-symbol'>&gt;</span> {t("kclGloves.Non_Resistant_Percent")}</li>
                            </ul>
                        </div>
                        <div className="col-sm-6 col-12">
                            <ul>
                                <li>0 : {t("kclGloves.Partial_Resistatn")} <span className='less-than-symbol'>&lt;</span> {t("kclGloves.Partial_Resistatn_Percent")}</li>
                                <li>Z : {t("kclGloves.Decomposition")}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row mx-0">
                        <div className="modal-subtitle">{t("kclGloves.Penetration")}</div>
                        <div className="col-sm-6 col-12 p-lg-0">
                            <ul>
                                <li><span>{t("kclGloves.Level")} 1:</span> {t("kclGloves.AQL4")}</li>
                            </ul>
                        </div>
                        <div className="col-sm-6 col-12">
                            <ul>
                                <li><span>{t("kclGloves.Level")} 2:</span> {t("kclGloves.AQL1")}</li>
                            </ul>
                        </div>
                        <div className="col-sm-6 col-12 p-lg-0">
                            <ul>
                                <li><span>{t("kclGloves.Level")} 3:</span> {t("kclGloves.AQL0")}</li>
                            </ul>
                        </div>
                        <p className="p-lg-0 level-style"><span>{t("kclGloves.Level")} 3 = </span> {t("kclGloves.ControlExplain")}</p>
                    </div>
                </Modal.Body>
            </Modal>
    );
};

export default ExplanationModal;